export default {
  tasksTimer: {}
}